import { ChainsReportState } from 'features/chains/store/chains-store';
import { selectChainsReportSearchSection } from '../select-chains-search-section';

export const selectChainsSearchSelectedCategories = (state: ChainsReportState) => {
    const chains = selectChainsReportSearchSection(state);

    return chains.selectedCategories;
};
